module.exports = __webpack_public_path__ + "static/media/logo.e08eafa6.svg";